import { Route } from 'react-router-dom';
import { CreatePaymentPage } from './create-payment';
import { EditPaymentPage } from './edit-payment';
import { ListPaymentsPage } from './list-payments';
import { ViewPaymentPage } from './view-payment';
import { RequireAuth } from '/src/components';

export { CreatePaymentPage, EditPaymentPage, ListPaymentsPage, ViewPaymentPage };

export const paymentsRoutes: React.ReactElement[] = [
  <Route
    path="/payments/create"
    element={
      <RequireAuth>
        <CreatePaymentPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/payments/:paymentId/edit"
    element={
      <RequireAuth>
        <EditPaymentPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/payments"
    element={
      <RequireAuth>
        <ListPaymentsPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/payments/:paymentId"
    element={
      <RequireAuth>
        <ViewPaymentPage />
      </RequireAuth>
    }
  />,
];
